export default "__VITE_ASSET__wyHwAJK1__"